import { createSlice } from '@reduxjs/toolkit';

import { CheckoutInfoPayload, CheckoutReduxState, GiftCard } from './';

import type { PayloadAction } from '@reduxjs/toolkit';
const initialState: CheckoutReduxState = {
	firstName: '',
	phone: '',
	email: '',
	giftCardPayments: [],
	balanceDue: 0,
	cartTotalPlusTax: 0,
	touched: false,
	reward: undefined
};

export const checkoutSlice = createSlice({
	name: 'checkout',
	initialState,
	reducers: {
		setBalanceDue: (state, action) => {
			state.balanceDue = action.payload;
		},
		setReward: (state, action) => {
			state.reward = action.payload;
		},
		setCartTotalPlusTax: (state, action) => {
			state.cartTotalPlusTax = action.payload;
		},
		setCheckoutInfo: (
			state,
			action: PayloadAction<CheckoutInfoPayload>
		) => {
			state.firstName = action.payload.firstName;
			state.email = action.payload.email;
			state.phone = action.payload.phone;
			state.touched = action.payload.touched;
		},
		setGiftCardInfo: (state, action) => {
			if (
				action.payload.giftCards &&
				action.payload.giftCards.length === 0
			) {
				state.giftCardPayments = [];
			} else {
				state.giftCardPayments = action.payload;
			}
		},
		addGiftCard: (
			state: CheckoutReduxState,
			action: PayloadAction<GiftCard>
		) => {
			// If the BIGGBY Card does not exist, add it to the list
			const existingCard = state.giftCardPayments.find(
				card => card.cardNumber === `${action.payload.card_number}`
			);

			if (!existingCard) {
				state.giftCardPayments.push({
					cardNumber: `${action.payload.card_number}`,
					amount: action.payload.cash
				});
			}
			// Update the balance due
			updateBalanceDue(state);
		},

		removeGiftCard: (state, action: PayloadAction<number>) => {
			const cardNumber = action.payload;
			const index = state.giftCardPayments.findIndex(
				payment => payment.cardNumber === `${cardNumber}`
			);

			if (index !== -1) {
				state.giftCardPayments.splice(index, 1);
			}

			updateBalanceDue(state);
		},

		clearGiftCardSelection: (state, action: PayloadAction<number>) => {
			state.giftCardPayments = [];
			state.balanceDue = action.payload;
			state.cartTotalPlusTax = action.payload;
		},

		clearCheckoutSlice: () => {
			return initialState;
		}
	}
});

const updateBalanceDue = (state: CheckoutReduxState) => {
	const totalGiftCardAmount = state.giftCardPayments.reduce(
		(sum, card) => sum + Number(card.amount),
		0
	);
	let balanceDue = state.cartTotalPlusTax - totalGiftCardAmount;
	balanceDue = Number(balanceDue.toFixed(2));
	state.balanceDue = balanceDue <= 0 ? 0 : balanceDue;
};

export const {
	setCheckoutInfo,
	setReward,
	setCartTotalPlusTax,
	setGiftCardInfo,
	removeGiftCard,
	addGiftCard,
	setBalanceDue,
	clearGiftCardSelection,
	clearCheckoutSlice
} = checkoutSlice.actions;
export default checkoutSlice.reducer;
